import React from 'react';

const TokenExpired = ({ errMsg }) => {
    return (
        <>
            <nav className="navbar navbar1 navbar-expand-lg navbar-light bg-light wow fadeInDown" data-wow-delay=".2s" data-wow-duration="0.7s" data-cy="navbar">
                {/* <button type="button" id="sidebarCollapse" className="btn btn-info" data-cy="menu-icon">
                    <img src={process.env.PUBLIC_URL + "/assets/images/icons/menu.png"} alt="menu-icon" />
                </button> */}
                <ul className="navbar-nav mr-auto">
                </ul>
                <div className="jiologo" data-cy="brand-logo"><a href="index.html"><img src={process.env.PUBLIC_URL + "/assets/images/new-jio-logo.svg"} alt="jio-logo" /></a></div>
                <div data-cy="settings-icon">
                    {/* <button className="btn btn-sm bg-light text-white" type="button" id="slideFilters" aria-expanded="false" aria-controls="collapseExample">
                        <i className="fa fa-2x fa-cog " aria-hidden="true"></i>
                    </button> */}
                </div>

                <ul className="userdropdown" data-cy="user-dropdown">
                    <li className="dropdown">
                        <a href="index.html" className="dropdown-toggle" data-toggle="dropdown">
                            <span> {sessionStorage.getItem('sAMAccountName')} </span>
                            {/* <i className="fa fa-3x fa-user-circle" aria-hidden="true"></i> */}
                        </a>
                        <ul className="dropdown-menu">
                            <li><a href="index.html" className="nobor">Sign Out </a></li>
                        </ul>
                    </li>
                </ul>
            </nav>
            <br />
            <div style={{ marginTop: 50 }}>
                <h1 className="tokenExpiryHeading">
                    {errMsg}
                </h1>
                <h3 className="tokenExpiryText">
                    <a href="https://pcsit.jioconnect.com:7701/group/guest/home">Come back with new token</a>
                </h3>
            </div>
        </>
    );
};

export default TokenExpired;